class PriceDiscountAmount extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateDiscount();
  }

  updateDiscount() {
    const parentElement = this.closest(".price.price--large");
    if (!parentElement || !parentElement.classList.contains("price--on-sale")) {
      this.style.display = "none";
      return;
    }

    this.style.display = "block";

    const regularPriceElement = parentElement.querySelector(
      ".price__sale .price-item--regular"
    );
    const salePriceElement = parentElement.querySelector(".price-item--sale");

    if (!regularPriceElement || !salePriceElement) {
      return;
    }

    const regularPrice = this.parsePrice(regularPriceElement.textContent);
    const salePrice = this.parsePrice(salePriceElement.textContent);

    if (isNaN(regularPrice) || isNaN(salePrice)) {
      return;
    }

    const discountAmount = Math.floor(regularPrice - salePrice);
    const currencySymbol = this.getAttribute("data-currency") || "€";
    const formattedDiscount = new Intl.NumberFormat().format(discountAmount);

    this.innerHTML = `-${formattedDiscount}&nbsp;${currencySymbol}`;
  }

  parsePrice(priceString) {
    const cleanedString = priceString
      .replace(/[^\d,.-]/g, "")
      .replace(".", "")
      .replace(",", ".");
    return parseFloat(cleanedString);
  }
}

if (!customElements.get("price-discount-amount")) {
  customElements.define("price-discount-amount", PriceDiscountAmount);
}
